// generic-client
import { useState } from 'react';
import { AirtmEnterpriseLogotype, IconCheck, Dropdown, Header } from '@airtm/airtm-ui';
import { LANGUAGES } from '@airtm/utils/dist/constants';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import getBaseURL from 'utils/getBaseURL';

const PublicHeader = function (props) {
  const { i18n } = useTranslation();
  const [opened, setOpen] = useState(false);
  const { showContent = true } = props;
  const landingUrl = getBaseURL();

  return (
    <Header id="header" className="header--public header--dark">
      <span className="d-none d-md-block col-1" />
      <Header.Brand className="d-block">
        <a href={landingUrl} className="d-flex">
          <AirtmEnterpriseLogotype className="text--white" />
        </a>
      </Header.Brand>
      {showContent && (
        <Header.Content>
          <Dropdown
            className="language-dropdown"
            onToggle={(toggle) => setOpen(toggle)}
            show={opened}
          >
            <Dropdown.Toggle>{i18n.language.toUpperCase()}</Dropdown.Toggle>
            <Dropdown.Menu autoPosition={false}>
              {LANGUAGES.map((language) => (
                <Dropdown.Item
                  key={language.isoCode}
                  onClick={() => i18n.changeLanguage(language.isoCode)}
                  className={language.isoCode === i18n.language ? 'dropdown-item__active' : ''}
                >
                  <div className="dropdown-item__language">{language.nativeName}</div>
                  {language.isoCode === i18n.language && (
                    <div className="dropdown-item__check">
                      <IconCheck />
                    </div>
                  )}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        </Header.Content>
      )}
      <span className="d-none d-md-block col-1" />
    </Header>
  );
};

PublicHeader.propTypes = {
  showContent: PropTypes.bool,
};

export default PublicHeader;
